import { createSlice } from '@reduxjs/toolkit';

import { authActions } from '../auth/index.js';

export interface ScoutingReportState {
    showPublishedNotification: boolean;
    ncaaYear?: string;
}

const scoutingReportDefaultState: ScoutingReportState = {
    showPublishedNotification: false,
};

const { reducer: scoutingReportReducer, actions: scoutingReportActions } = createSlice({
    name: 'scoutingReport',
    initialState: scoutingReportDefaultState,
    reducers: {
        ShowPublishedNotification: (state, action) => {
            state.showPublishedNotification = action.payload;
        },

        SetNCAAYear: (state, action) => {
            state.ncaaYear = action.payload;
        },
    },
    extraReducers: (builder) => builder.addCase(authActions.PurgeProfile, () => scoutingReportDefaultState),
});

export { scoutingReportReducer, scoutingReportActions, scoutingReportDefaultState };
